module.exports = __webpack_public_path__ + "static/media/4-R-Smart Expert-c.0ef3f690.jpg";